import React from 'react';
import { LoadIndicatorView } from '@vivli/shared/views';
import { LoadIndicatorSizeEnum } from '@vivli/shared/infrastructure/enum';

export const DataPackageLoaderComponent = () => (
    <LoadIndicatorView style={{ width: '100%', minHeight: '200px' }} size={LoadIndicatorSizeEnum.Medium} />
);
